import React from 'react';
interface TOCItem {
  id: string;
  title: string;
  level: number;
}
interface TableOfContentsProps {
  items: TOCItem[];
}
const TableOfContents: React.FC<TableOfContentsProps> = ({
  items
}) => {
  return <div className="sticky top-20 p-4 bg-gray-50 rounded-lg shadow-sm" data-id="element-138">
      <h3 className="text-lg font-medium text-gray-900 mb-3" data-id="element-139">On this page</h3>
      <nav className="space-y-1" data-id="element-140">
        {items.map(item => <a key={item.id} href={`#${item.id}`} className={`block text-gray-600 hover:text-gray-900 hover:bg-gray-100 px-2 py-1 rounded text-sm ${item.level > 1 ? 'pl-4' : ''}`} data-id="element-141">
            {item.title}
          </a>)}
      </nav>
    </div>;
};
export default TableOfContents;